import type { QuickFilterProps } from '../../../../../../components/SearchPage/features/QuickFilters/components/QuickFilter/QuickFilter.typed';

import { useQuickFilter } from '../../../../../../components/SearchPage/features/QuickFilters/components/QuickFilter/QuickFilter.hook';

import * as Styled from '../../../../../../components/SearchPage/features/QuickFilters/components/QuickFilter/QuickFilter.styled';
import { shouldShowTrims } from '../../../makeModel/MakeModel.constants';

const QuickFilter = (props: QuickFilterProps) => {
  const { filter, displayText, sectionName } = props;

  const { ref, onClick, quickFilterID } = useQuickFilter({
    filter,
  });

  // TODO:This isn't ideal, Make this backend driven.
  // If the API is updated now, the title will be incorrect on production.
  // We should merge this before after go live and come back and tidy up.
  // https://github.com/distilledmedia/dsch-dd-filters/pull/451/files

  const isSelected =
    filter.name === 'makeModel'
      ? displayText !==
        (shouldShowTrims(sectionName) ? 'Make, Model & Trim' : 'Make / Model')
      : displayText !== filter.displayName;

  return (
    <Styled.FilterButton
      ofType="SECONDARY"
      onClick={onClick}
      inline
      ref={ref}
      isSelected={isSelected}
      data-tracking={quickFilterID}
      data-testid={quickFilterID}
    >
      {displayText}
    </Styled.FilterButton>
  );
};

export { QuickFilter };
